import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cig-audio',
  templateUrl: './cig-audio.component.html',
  styleUrls: ['./cig-audio.component.scss']
})
export class CigAudioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
